export enum MaintenanceStatus {
    UP = 'up',
    MAINTENANCE = 'maintenance',
}

export const trespassUsers = [
    'victor@malou.io',
    'waad@malou.io',
    'mathilde@malou.io',
    'fantin@malou.io',
    'solene@malou.io',
    'rafik@malou.io',
];

export const techTeamUsers = [
    'amira@malou.io',
    'ana@malou.io',
    'aymen@malou.io',
    'baptiste@malou.io',
    'cyril@malou.io',
    'hamza@malou.io',
    'helene@malou.io',
    'lise@malou.io',
    'madjid@malou.io',
    'maxime@malou.io',
    'tanguy.roudaut@malou.io',
    'victor@malou.io',
    'waad@malou.io',
];
